import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CFormText } from "@coreui/react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { Input } from "../../../../components/form/Input/Input";
import { setSelected } from "../redux/rolesSagas";

export const Filters = () => {
  const dispatch = useDispatch();

  const {
    selected: { organization, name, identifier },
    currentUser: { organizations }
  } = useSelector((state) => state.roles);

  const onOrganizationChange = (selected) => {
    dispatch(setSelected({ organization: selected }));
  };

  const onInputChange = (title, key) => {
    dispatch(setSelected({ [key]: title }));
  };

  return (
    <>
      <div className="roles__section light">
        <div className="roles__section__el">
          <p>Organizations</p>
          <Dropdown
            height={275}
            haveOnSelectChange
            placeholder="Select Organization"
            options={organizations}
            selectedFilters={organization}
            numberDisplayed={3}
            onSelectChange={(data) => onOrganizationChange(data)}
          />
          <CFormText className="help-block">
            {!organization ? "Please choose at least 1 organization" : ""}
          </CFormText>
        </div>

        <div className="roles__section__el">
          <p>Name</p>
          <Input
            onChange={(value) => onInputChange(value, "name")}
            className="text-input"
            placeholder="Add Name"
            value={name}
          />
          <CFormText className="help-block">
            {name && name.trim() ? "" : "* Please add name"}
          </CFormText>
        </div>

        <div className="roles__section__el">
          <p>Identifier</p>
          <Input
            onChange={(value) => onInputChange(value, "identifier")}
            className="text-input"
            placeholder="Add Identifier"
            value={identifier}
          />
          <CFormText className="help-block">
            {identifier && identifier.trim() ? "" : "* Please add identifier"}
          </CFormText>
        </div>
      </div>
    </>
  );
};
